import axios from '../../../axios';

const url = '/candidatesearch/api/mail-templates/';

export const getEmailTemplates = () => axios.get(url);

export const getUserOrTeamEmailTemplates = () => axios.get(`${url}user-or-team-ids`);
